import React, { createContext, useContext } from "react";
import { useUserLogic } from "../hooks/useUser";


type UserContextType = ReturnType<typeof useUserLogic>;

const UserContext = createContext<UserContextType | null>(null);

type Props = {
  children: React.ReactNode;
};

export const UserProvider = ({ children }: Props) => {
  const user = useUserLogic(); 
  return (
    <UserContext.Provider value={user}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook for accessing user context
export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
}
